import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Settings } from '../core';
import { Observable, of, combineLatest } from 'rxjs';
import { SponsorSubjectsReadModel } from './sponsor-subjects-read-model';
import { map, flatMap, switchAll, filter } from 'rxjs/operators';
import { deserialize } from 'santee-dcts';
import { SponsorStudy } from '../sponsor-dashboard/sponsor-study';
import { SponsorSubject } from './sponsor-subject';
import { isEmpty } from 'lodash';
import { SponsorSubjectIdentity, SponsorSubjectIdentitiesReadModel } from './sponsor-subject-item';
import { SponsorStudySiteIdentity } from './sites/sponsor-study-site-identity';

@Injectable()
export class SponsorSubjectsStorage {
    constructor(
        private settings: Settings,
        private http: HttpClient
    ) { }

    public loadSubjectIdentitiesByStudy(study: SponsorStudy): Observable<SponsorSubjectIdentity[]> {
        return this.http.get(`${this.settings.apiUrl}/sponsor/study/${study.protocolId}/subject-identities`).pipe(
            map((response) => deserialize(response, SponsorSubjectIdentitiesReadModel).subjectIdentities),
        );
    }

    public loadSubjectsByStudy(study: Observable<SponsorStudy>): Observable<SponsorSubject[]> {
        return study.pipe(
            map(x => {
                return this.http.get(`${this.settings.apiUrl}/sponsor/study/${x.protocolId}/subjects`).pipe(
                    map((response) => deserialize(response, SponsorSubjectsReadModel).subjects),
                );
            }),
            flatMap(x => of(of(null), x)),
            switchAll()
        );
    }

    public loadSubjectsByStudySiteIdentities(study$: Observable<SponsorStudy>, sites$: Observable<SponsorStudySiteIdentity[]>): Observable<SponsorSubject[]> {
        return combineLatest(study$, sites$.pipe(filter(sites => !isEmpty(sites))))
            .pipe(
                map(([study, sites]) => {
                    const sitesParamString = sites.map(s => `siteids=${s.siteId}`).join('&');
                    return this.http.get(`${this.settings.apiUrl}/sponsor/study/${study.protocolId}/subjects?${sitesParamString}`).pipe(
                        map((response) => deserialize(response, SponsorSubjectsReadModel).subjects),
                    );
                }),
                flatMap(x => of(of(null), x)),
                switchAll()
        );
    }

    public getCTProtocolId(protocolcode: string, sponsorName: string): Observable<number> {
        let requestInfo = {
            protocolCode: protocolcode,
            sponsorName: sponsorName
        };
        return this.http.post(`${this.settings.apiUrl}/sponsor/protocolidctsql`, requestInfo)
            .pipe(
                map((protocolId: number) => {
                    return protocolId;
                }),
            );
    }
}